import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  Fragment,
} from "react";
import ReactSelect from "react-select";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import AddressInput from "../../components/AddressInput";
import NoteItem from "../../components/NoteItem";
import Firebase from "../../firebasehelper";
import {
  gender,
  profession,
  user_origin_types,
  user_access,
} from "../../Constants/selections";
import { getStringfromSeconds, idealTextColor } from "../../functions";
import ViewReferralModal from "./ViewReferralModal";
import { useLocation } from "react-router-dom";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  grid: {
    marginTop: 10,
  },
  cta: {
    display: "flex",
    flexDirection: "row",
    marginTop: "20px",
    marginBottom: "20px",
    alignItems: "center",
  },
  button: {
    marginLeft: "auto",
  },
  front: {
    zIndex: 1,
  },
}));

const phoneImg = require("../../assets/media/profile/phone.png");
const emailImg = require("../../assets/media/mail.png");
const accountantImg = require("../../assets/media/profile/accountant.png");
const categoryImg = require("../../assets/media/profile/category.png");
const ageImg = require("../../assets/media/profile/gift.png");
const nameImg = require("../../assets/media/id.png");
const internalIdImg = require("../../assets/media/face-id.png");
const professionImg = require("../../assets/media/settings.png");
const addressImg = require("../../assets/media/map-location.png");
const defaultAvatar = require("../../assets/media/profile/avatar.png");
const uidImg = require("../../assets/media/profile/uid.png");
const referralImg = require("../../assets/media/profile/referral.png");
const locationImg = require("../../assets/media/profile/location.png");
const userAccessImg = require("../../assets/media/profile/access.png");
const remove_icon = require("../../assets/media/stop.png");

const getColorByStatus = (status) => {
  switch (status) {
    case "Open":
      return "#7Ef0a7";
    case "Waiting":
      return "#ED6836";
    case "Closed":
      return "red";
    default:
      return "green";
  }
};

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ProfileItem = ({
  imgSrc,
  name,
  value,
  itemString,
  title,
  editable = true,
  onAction,
  categories,
  onToggleEditing,
  onChange,
  territory,
}) => {
  // -- hook
  const [isEditing, setIsEditing] = useState(false);
  const [itemValue, setItemValue] = useState(value);
  const [agencies, setAgencies] = useState([]);
  const location = useLocation();
  useEffect(() => {
    if (name !== "accountant") return;
    const { brand } = location.state;
    Firebase.getAgencyByBrandID(brand, (res) => {
      setAgencies(
        res.filter((item) =>
          [
            "Sales manager",
            "Account manager",
            "Sales rep",
            "Service manager",
            "Service rep",
          ].includes(item.type)
        )
      );
    });
  }, []);

  useEffect(() => {
    setItemValue(value);
  }, [value]);

  const getOptions = (name) => {
    switch (name) {
      case "address":
        return [{ value: itemValue, label: itemValue }];
      case "gender":
        return gender.map((item) => ({ value: item, label: item }));
      case "profession":
        return profession.map((item) => ({ value: item, label: item }));
      case "origin":
        return user_origin_types.map((item) => ({
          value: item,
          label: item,
        }));
      case "category": {
        return categories.map((item) => ({
          value: item.categoryTitle,
          label: item.categoryTitle,
        }));
      }
      case "accountant": {
        return [
          { value: null, label: "none" },
          ...agencies.map((item) => ({
            value: item.uid,
            label: item.username,
          })),
        ];
      }
      case "access": {
        return user_access;
      }
      default:
        return [];
    }
  };

  // -- handler
  const handleOnChange = ({ target }) => {
    setItemValue(target.value);
    onChange(target.value);
  };
  const handleClickSetting = () => {
    setIsEditing(!isEditing);
    if (isEditing) {
      //saving...
      onToggleEditing(-1);
      if (itemValue) onChange(itemValue);
    } else {
      onToggleEditing(1);
    }
  };
  const handleChangeSelect = ({ value }) => {
    setItemValue(value);
    onChange(value);
  };
  const handleOnChangeAddress = (value) => {
    setItemValue(value);
    onChange(value);
  };

  const copyMagicLink = (magic_link) => {
    navigator.clipboard.writeText(magic_link);
    onAction("Copied to clipboard!");
  };

  return (
    <div className="profile-item">
      <img src={imgSrc} alt="icon" width="30px" />

      {isEditing ? (
        <Fragment>
          {[
            "gender",
            "profession",
            "access",
            "accountant",
            "category",
          ].includes(name) ? (
            <div
              className="form-group"
              style={{ width: "100%", marginBottom: 0 }}
            >
              <ReactSelect
                value={
                  name === "access"
                    ? user_access.find((access) => access.value === itemValue)
                    : getOptions(name).find((item) => item.value === itemValue)
                }
                onChange={handleChangeSelect}
                options={getOptions(name)}
              />
            </div>
          ) : name === "address" ? (
            <AddressInput
              onGetAddress={handleOnChangeAddress}
              oldAddress={itemValue}
            />
          ) : (
            <input
              type="text"
              className="form-control"
              name={name}
              value={itemValue}
              onChange={handleOnChange}
            />
          )}
          <i className="si si-check ml-2" onClick={handleClickSetting} />
        </Fragment>
      ) : (
        <Fragment>
          <p>
            {title && (
              <span
                style={{
                  fontWeight: "bold",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                {title}
              </span>
            )}
            {itemValue
              ? name === "address" && territory === "USA"
                ? `${itemValue.address1}, ${itemValue.city}, ${itemValue.state}, ${itemValue.zipcode}`
                : name === "access"
                ? user_access.find((access) => access.value === itemValue).label
                : (
                    getOptions(name).find(
                      (item) => item.value === itemValue
                    ) || { label: itemValue }
                  ).label
              : name === "magic_link"
              ? ""
              : itemString}
          </p>
          {editable && (
            <i className="si si-settings ml-2" onClick={handleClickSetting} />
          )}
          {name === "magic_link" && (
            <button
              className="btn btn-white copy-magic"
              onClick={() => copyMagicLink(itemString)}
            >
              Copy Link
            </button>
          )}
          {name === "referral_code" && (
            <button
              className="btn btn-white view-referrals"
              data-toggle="modal"
              data-target="#view_referral_modal"
            >
              View referrals
            </button>
          )}
        </Fragment>
      )}
    </div>
  );
};

const TicketItem = ({ ticket, onClick, active }) => {
  return (
    <div className="ticket" onClick={onClick}>
      <div
        style={{
          maxWidth: 500,
          display: "flex",
          flexDirection: "row",
          fontSize: 11,
        }}
      >
        <p style={{ marginRight: "2px" }}>
          {getStringfromSeconds(ticket.time)}
        </p>
        <p>
          {/* &nbsp;&nbsp;&nbsp;<b>Ticket</b>&nbsp;:&nbsp; */}
          {ticket.title === "Support"
            ? "Support"
            : `Concierge: ${ticket.title}`}
        </p>
      </div>
      <button className="chat-button btn-orange">Chat</button>
      <p
        style={{
          color: getColorByStatus(ticket.status),
          fontWeight: "bold",
          fontStyle: "normal",
          fontSize: 12,
        }}
      >
        {ticket.status}
      </p>
    </div>
  );
};
const ManifestModal = React.forwardRef(
  (
    {
      user,
      brandData,
      categories,
      isChatCRMNotVisible,
      onChangeProfile,
      onClickTicket,
      onClickAttachment,
      removeUser,
    },
    ref
  ) => {
    const [profile, setProfile] = useState({ avatar_url: defaultAvatar });
    const [tickets, setTickets] = useState([]);
    const [editingCount, setEditingCount] = useState(0);
    const [selectedTicket, setSelectedTicket] = useState({ id: "null" });
    const [userCategories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [brandChanges, setBrandChanges] = useState({});
    const [ecoChanges, setEcoChanges] = useState({});
    const [openCopyMagicLink, setOpenCopyMagicLink] = useState(null);
    const hiddenBtnRef = useRef();

    useImperativeHandle(ref, () => ({
      close() {
        close();
      },
    }));

    useEffect(() => {
      async function loadProfile() {
        setLoading(true);
        const { eco_id, id } = user;
        let ecoData = {};
        if (eco_id) {
          ecoData = await Firebase.getEcoUserbyId(eco_id);
        }
        let res = await Firebase.getUserDatafromUID(brandData.name, id);
        res = { ...res, ...ecoData };
        setProfile(res);
        setLoading(false);
      }
      loadProfile();
      loadTickets();
      setSelectedTicket({ id: "null" });
      if (categories && categories.length > 0) setCategories(categories);
      user_access[
        user_access.findIndex((access) => access.value === "Brandname employee")
      ] = {
        value: "Brandname employee",
        label: `Member - ${brandData.name} employee`,
      };
      user_access[
        user_access.findIndex(
          (access) => access.value === "Friend of brandname"
        )
      ] = {
        value: "Friend of brandname",
        label: `Member - Friend of ${brandData.name}`,
      };
    }, [user, brandData.name, categories]);
    const classes = useStyles();

    const handleChangeProfile = (name, isBrandProfile) => (value) => {
      if (isBrandProfile) {
        setBrandChanges({ ...brandChanges, [name]: value });
      } else {
        setEcoChanges({ ...ecoChanges, [name]: value });
        if (name === "firstname") {
          setBrandChanges({ ...brandChanges, [name]: value });
        }
      }
    };
    const handleClickTicket = (ticket) => () => {
      onClickTicket(ticket);
      setSelectedTicket(ticket);
    };
    const loadTickets = async () => {
      if (user.id) {
        Firebase.getUserTickets(user.id, (ticket) => {
          if (ticket) setTickets(Object.values(ticket));
          else setTickets([]);
        });
      }
    };
    const close = () => {
      hiddenBtnRef.current.click();
    };

    const onToggleEditing = (value) =>
      setEditingCount((count) => count + value);

    const getBespokeUrl = () => {
      const { bespokeUrl, name } = brandData;
      const { id } = user;

      const magicLink = bespokeUrl
        ? `${bespokeUrl}?uid=${id}`
        : brandData === "WeShare"
        ? `https://uhsm.app?uid=${id}`
        : `https://ecosystem.life/${name.replaceAll(" ", "")}?uid=${id}`;

      return magicLink;
    };

    return (
      <Fragment>
        <div
          className="modal fade"
          id="manifest_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-default-fadein"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ maxWidth: "1200px" }}
          >
            <div className="modal-content">
              <div className="modal-body pb-1">
                {loading && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <i className="fa fa-4x fa-sync fa-spin text-muted" />
                  </div>
                )}
                {!loading && (
                  <div className={classes.root}>
                    <Grid container spacing={3}>
                      <Grid item xs={4}>
                        <Grid container spacing={3}>
                          <Grid item xs={4} className={classes.grid}>
                            <img
                              src={profile.avatar_url || defaultAvatar}
                              className="profile-img"
                              alt="avatar"
                            />
                          </Grid>
                          <Grid item xs={8} className={classes.grid}>
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={nameImg}
                              value={
                                profile.firstname &&
                                profile.firstname.replace(" ", "-")
                              }
                              itemString="Name"
                              name="firstname"
                              onChange={handleChangeProfile("firstname", false)}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={nameImg}
                              value={profile.surname}
                              itemString="Surname"
                              name="surname"
                              editable={false}
                              onChange={handleChangeProfile("surname", false)}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={internalIdImg}
                              value={profile.internal_id}
                              itemString="Lead internal iD"
                              name="internal_id"
                              onChange={handleChangeProfile(
                                "internal_id",
                                true
                              )}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={internalIdImg}
                              value={profile.person_id}
                              itemString="Person account iD"
                              name="person_id"
                              onChange={handleChangeProfile("person_id", true)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={8}>
                        <Grid container spacing={3}>
                          <Grid item xs={6} className={classes.grid}>
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={uidImg}
                              itemString={user.id}
                              title="UID"
                              name="uid"
                              editable={false}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={uidImg}
                              itemString={getBespokeUrl()}
                              title="Magic Link"
                              name="magic_link"
                              onAction={setOpenCopyMagicLink}
                              editable={false}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={referralImg}
                              itemString={
                                profile.firstname &&
                                user.id &&
                                `${profile.firstname
                                  .slice(0, 2)
                                  .toUpperCase()}${user.id.slice(-6)}`
                              }
                              title="Referral code"
                              name="referral_code"
                              editable={false}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={addressImg}
                              value={profile.address}
                              itemString="Address"
                              name="address"
                              onChange={handleChangeProfile("address", true)}
                              territory={brandData.territory}
                            />
                          </Grid>
                          <Grid item xs={6} className={classes.grid}>
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={accountantImg}
                              value={profile.accountant}
                              itemString="Select an account or sales manager"
                              name="accountant"
                              onChange={handleChangeProfile("accountant", true)}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={categoryImg}
                              value={profile.category}
                              itemString="User internal categorisation"
                              name="category"
                              categories={userCategories}
                              onChange={handleChangeProfile("category", true)}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={userAccessImg}
                              value={profile.user_access || "Member"}
                              itemString="User access categorisation"
                              name="access"
                              onChange={handleChangeProfile(
                                "user_access",
                                true
                              )}
                            />
                            <ProfileItem
                              onToggleEditing={onToggleEditing}
                              imgSrc={locationImg}
                              itemString="Pending GPS check-in"
                              title="Location"
                              name="location"
                              editable={false}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid
                        item
                        xs={3}
                        className={(classes.grid, classes.front)}
                      >
                        <h4>Data</h4>
                        <ProfileItem
                          onToggleEditing={onToggleEditing}
                          imgSrc={phoneImg}
                          value={profile.phonenumber}
                          itemString="Mobile"
                          editable={false}
                        />
                        <ProfileItem
                          onToggleEditing={onToggleEditing}
                          imgSrc={emailImg}
                          value={
                            profile.email ||
                            `${
                              profile.firstname &&
                              user.id &&
                              `${profile.firstname
                                .slice(0, 2)
                                .toUpperCase()}${user.id.slice(-6)}`
                            }@ecosystem.life`
                          }
                          itemString="Email"
                          name="email"
                          editable={false}
                          onChange={handleChangeProfile("email", false)}
                        />
                        {/* <ProfileItem
                        imgSrc={genderImg}
                        value={profile.gender}
                        itemString="Gender"
                        name="gender"
                        onChange={handleChangeProfile("gender", false)}
                      /> */}
                        <ProfileItem
                          onToggleEditing={onToggleEditing}
                          imgSrc={ageImg}
                          value={profile.dob}
                          itemString="Birthday"
                          name="dob"
                          editable={false}
                          onChange={handleChangeProfile("dob", false)}
                        />
                        <ProfileItem
                          onToggleEditing={onToggleEditing}
                          imgSrc={professionImg}
                          value={profile.profession}
                          itemString="Profession"
                          name="profession"
                          editable={false}
                          onChange={handleChangeProfile("profession", false)}
                        />
                      </Grid>
                      {!isChatCRMNotVisible && (
                        <Grid item xs={5} className={classes.grid}>
                          <h4>Tickets</h4>
                          <div
                            style={{
                              maxHeight: 200,
                              overflow: "auto",
                              padding: "10px",
                            }}
                          >
                            {tickets
                              .filter((t) => t.id)
                              .map((ticket) => (
                                <TicketItem
                                  ticket={ticket}
                                  onClick={handleClickTicket(ticket)}
                                  active={
                                    selectedTicket.id === ticket.id
                                      ? true
                                      : false
                                  }
                                />
                              ))}
                          </div>
                          <button
                            className="btn btn-white create-ticket-button"
                            style={{
                              "--hover-color": brandData.hex,
                            }}
                          >
                            Create a new ticket
                          </button>
                        </Grid>
                      )}
                      {!isChatCRMNotVisible && (
                        <Grid item xs={4} className={classes.grid}>
                          <h4>Notes</h4>
                          {selectedTicket && selectedTicket.note && (
                            <div
                              style={{
                                height: 200,
                                overflow: "auto",
                              }}
                            >
                              {selectedTicket.note
                                .sort(
                                  (a, b) => parseInt(b.time) - parseInt(a.time)
                                )
                                .map((item, index) => (
                                  <NoteItem
                                    key={index}
                                    note={item}
                                    onClickAttachment={onClickAttachment}
                                  />
                                ))}
                            </div>
                          )}
                          <div className="row-div">
                            <button
                              className="btn add-button mr-5 btn-brand-hex"
                              data-toggle="modal"
                              data-target="#add_note_dialog"
                              disabled={selectedTicket.id === "null"}
                              style={{
                                "--hover-color": brandData.hex,
                                "--hover-text-color": brandData.hex
                                  ? idealTextColor(brandData.hex)
                                  : "black",
                              }}
                            >
                              Add note
                            </button>
                            <button
                              className="btn add-button btn-brand-hex"
                              data-toggle="modal"
                              data-target="#schedule-meeting"
                              style={{
                                "--hover-color": brandData.hex,
                                "--hover-text-color": brandData.hex
                                  ? idealTextColor(brandData.hex)
                                  : "black",
                              }}
                            >
                              Add appointment
                            </button>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                    <Divider />
                    <div className={classes.cta}>
                      {!user.isDemo && (
                        <React.Fragment>
                          <p>Delete member profile</p>
                          <p
                            className="member-close"
                            data-toggle="modal"
                            data-target="#remove_user"
                            onClick={() => {
                              removeUser(user);
                            }}
                          >
                            <img
                              src={remove_icon}
                              className="remove-icon"
                              alt="remove"
                            />
                          </p>
                        </React.Fragment>
                      )}
                      <button
                        className={`btn btn-${
                          editingCount ? "orange" : "green"
                        }`}
                        style={{ marginLeft: "auto" }}
                        onClick={() => {
                          if (editingCount) {
                            setOpenCopyMagicLink("Save your entry!");
                            return;
                          }
                          onChangeProfile({
                            ecoChanges,
                            brandChanges,
                          });
                          close();
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <button
              ref={hiddenBtnRef}
              data-dismiss="modal"
              data-target="#manifest_modal"
              style={{ visibility: "hidden" }}
            ></button>
          </div>
        </div>
        <Snackbar
          open={openCopyMagicLink !== null}
          anchorOrigin={{ horizontal: "right", vertical: "top" }}
          autoHideDuration={4000}
          onClose={() => setOpenCopyMagicLink(null)}
        >
          <Alert onClose={() => setOpenCopyMagicLink(null)} severity="success">
            {openCopyMagicLink}
          </Alert>
        </Snackbar>
        <ViewReferralModal user={user} brandData={brandData} />
      </Fragment>
    );
  }
);
export default ManifestModal;



// WEBPACK FOOTER //
// ./src/screens/Users/ManifestModal.js